import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ff8df17"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "detail"
}
const _hoisted_3 = {
  key: 0,
  class: "text"
}
const _hoisted_4 = {
  key: 1,
  class: "text"
}
const _hoisted_5 = {
  key: 2,
  class: "text"
}
const _hoisted_6 = {
  key: 3,
  class: "text"
}
const _hoisted_7 = {
  key: 4,
  class: "text"
}
const _hoisted_8 = {
  key: 5,
  class: "text"
}
const _hoisted_9 = {
  key: 6,
  class: "text"
}
const _hoisted_10 = {
  key: 7,
  class: "text"
}
const _hoisted_11 = {
  key: 8,
  class: "text"
}
const _hoisted_12 = {
  key: 9,
  class: "text"
}
const _hoisted_13 = { class: "grade" }
const _hoisted_14 = { class: "grade" }
const _hoisted_15 = { class: "grade" }
const _hoisted_16 = { class: "grade" }
const _hoisted_17 = { class: "grade" }
const _hoisted_18 = { class: "grade" }
const _hoisted_19 = { class: "grade" }
const _hoisted_20 = { class: "grade" }
const _hoisted_21 = { class: "grade" }
const _hoisted_22 = { class: "grade" }
const _hoisted_23 = { class: "dropdown-menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tree = _resolveComponent("a-tree")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!

  return (_ctx.isShow)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.settingShow && _ctx.checkId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", null, [
                (_ctx.list?.car_speed_type)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.t("speed")) + "：", 1))
                  : _createCommentVNode("", true),
                (_ctx.list?.roller_pressure)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.t("rollingbrushpressure")) + "： ", 1))
                  : _createCommentVNode("", true),
                (_ctx.list?.roller_speed)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.t("rollingbrushspeed")) + "： ", 1))
                  : _createCommentVNode("", true),
                (_ctx.list?.edge_brush_speed)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.t("edgebrushspeed")) + "： ", 1))
                  : _createCommentVNode("", true),
                (_ctx.list?.water_consumption)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.t("watercapacity")) + "： ", 1))
                  : _createCommentVNode("", true),
                (_ctx.list?.water_absorption)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.t("bibulouscrouching")) + "： ", 1))
                  : _createCommentVNode("", true),
                (_ctx.list?.exhaust_level)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.t("suctionlevel")) + "： ", 1))
                  : _createCommentVNode("", true),
                (_ctx.list?.brush_pressure)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.t("edgebrushpressure")) + "： ", 1))
                  : _createCommentVNode("", true),
                (_ctx.list?.dust)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.t("dustmop")) + "：", 1))
                  : _createCommentVNode("", true),
                (_ctx.list?.detergent)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.t("detergentconcentration")) + "： ", 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.list?.car_speed_type), 1),
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.list?.roller_pressure), 1),
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.list?.roller_speed), 1),
                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.list?.edge_brush_speed), 1),
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.list?.water_consumption), 1),
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.list?.water_absorption), 1),
                _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.list?.exhaust_level), 1),
                _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.list?.brush_pressure), 1),
                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.list?.dust), 1),
                _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.list?.detergent), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_a_dropdown, {
          trigger: ['click'],
          open: _ctx.settingShow,
          "onUpdate:open": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.settingShow) = $event))
        }, {
          overlay: _withCtx(() => [
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_a_tree, {
                "selected-keys": _ctx.selectedKeys,
                "field-names": _ctx.defaultProps,
                "tree-data": _ctx.detail.task_list,
                selectable: "",
                "auto-expand-parent": true,
                onSelect: _ctx.handleNodeClick
              }, null, 8, ["selected-keys", "field-names", "tree-data", "onSelect"])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "a-dropdown-link title",
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
            }, _toDisplayString(_ctx.t("cleaningmode")), 1)
          ]),
          _: 1
        }, 8, ["open"])
      ]))
    : _createCommentVNode("", true)
}